import React, { useContext, useEffect, useRef, useState } from "react";
import { apiGet } from "../../utils/apiFetch";
import Pagination from "../Pagination";
import dayjs from "dayjs";
import ODateRangePicker from "components/shared/datePicker/ODateRangePicker";
import { useTranslation } from "react-i18next";
import OSearch from "components/reusable/OSearch";
import apiPath from "utils/apiPath";
import { BiReset } from "react-icons/bi";
import CustomerTable from "./VehicleTable";
import helpers from "utils/helpers";
import AnimatedComponent from "components/reusable/AnimatedComponent";
import { IoMdAdd } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import AuthContext from "context/AuthContext";
import VehicleAdd from "./VehicleAdd";

function VehicleManager() {
  const { t } = useTranslation();
  const childRef = useRef();
  const navigate = useNavigate()
  const [customer, setCustomer] = useState([]);
  const { user, updatePageName } = useContext(AuthContext);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [isInitialized, setIsInitialized] = useState(false);
  const [categoryAdd, setCategoryAdd] = useState('');
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10,
  });
  const [filterData, setFilterData] = useState({
    category: "",
    searchkey: "",
    startDate: "",
    role: '',
    endDate: "",
    isReset: false,
    isFilter: false,
  });

  const handleCategory = () => {
    setCategoryAdd('');
  };

  useEffect(() => {
    updatePageName(t('VEHICLE_MANAGER'))
  }, [])
  const [sort, setSort] = useState({
    sortKey: "createdAt",
    sortType: "desc",
  });

  const allSubAdmin = async (task = "listing") => {
    try {
      const { category, startDate, endDate, searchkey, role } = filterData;

      const payload = {
        page,
        pageSize: pageSize,
        status: category,
        startDate: startDate ? dayjs(startDate).format("YYYY-MM-DD") : null,
        endDate: endDate ? dayjs(endDate).format("YYYY-MM-DD") : null,
        keyword: helpers.ternaryCondition(searchkey?.includes('+'), searchkey?.split('-')?.[1], searchkey),
        sortKey: sort.sortKey,
        sortType: sort.sortType,
        role,
        timezone: new Date().getTimezoneOffset(),
      };


      const path = apiPath.getVehicleList;
      const result = await apiGet(path, payload);
      const response = result?.data?.results;
      const resultStatus = result?.data?.success;
      if (task === "listing") {
        setCustomer(response?.docs);
      } else {
        helpers.downloadFile(response?.csvFilePath);
      }
      setPaginationObj({
        ...paginationObj,
        page: resultStatus ? response.page : null,
        pageCount: resultStatus ? response.totalPages : null,
        perPageItem: resultStatus ? response?.docs.length : null,
        totalItems: resultStatus ? response.totalDocs : null,
      });
    } catch (error) {
      console.error("error in get all sub admin list==>>>>", error.message);
    }
  };
  const handlePageClick = (event) => {
    const newPage = event.selected + 1;
    setPage(newPage);
  };


  useEffect(() => {
    allSubAdmin("listing");
  }, [filterData, page, sort]);

  const handleReset = () => {
    setSearchTerm("");
    setFilterData({
      category: "",
      searchkey: "",
      startDate: "",
      endDate: "",
      role: '',
      isReset: true,
      isFilter: false,
    });
    setPage(1);
    childRef?.current?.onClose();
  };

  const handleDateChange = (start, end) => {
    setPage(1);
    setFilterData({
      ...filterData,
      isReset: false,
      startDate: start,
      endDate: end,
      isFilter: true,
    });
  };
  const statusPage = (e) => {
    setPage(1);
    setFilterData({
      ...filterData,
      isReset: false,
      category: e.target.value,
      isFilter: true,
    });
  };


  useEffect(() => {
    if (!isInitialized) {
      setIsInitialized(true);
    } else if (searchTerm || !filterData?.isReset) {
      setFilterData({
        ...filterData,
        isReset: false,
        searchkey: debouncedSearchTerm ? debouncedSearchTerm : "",
        isFilter: debouncedSearchTerm ? true : false,
      });
      setPage(1);
    }
  }, [debouncedSearchTerm]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm.trim());
    }, 500);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [searchTerm]);

  return (
    <div>
      <div className="bg-[#F9F9F9] dark:bg-LightBlue">
        <div className="px-3 py-4">
          <div className="bg-white border border-[#E9EDF9] rounded-lg dark:bg-slate-800">
            {/* filter section */}
            <form className="border-b border-b-[#E3E3E3] 2xl:flex gap-2 px-4 py-3 flex-wrap justify-between">
              <div className="col-span-2 flex flex-wrap  items-center">
                <div className="flex items-center lg:pt-0 pt-3 flex-wrap justify-center mb-2 2xl:mb-0">
                  <div className="relative flex items-center mb-3">
                    <OSearch
                      placeholders={t("SEARCH_BY_VEHICLE_NUMBER")}
                      onChange={(e) => {
                        setSearchTerm(e?.target?.value);
                      }}
                      className="w-[300px] h-[38px] rounded-lg"
                      ref={childRef}
                    />

                  </div>
                  <ODateRangePicker handleDateChange={handleDateChange} isReset={filterData?.isReset} setIsReset={setFilterData} />
                  <div className="flex items-center ml-3 mb-3">
                    <select
                      id=""
                      type="text "
                      name="category"
                      className="block p-2 w-full text-sm text-[#A5A5A5] bg-transparent border-2 dark:border-[#fff] rounded-lg border-[#DFDFDF]  dark:text-[#A5A5A5] dark:border-gray-600"
                      placeholder=" "
                      onChange={(e) => statusPage(e)}
                      value={filterData?.category}
                    >
                      <option defaultValue value="">
                        {t("O_ALL")}
                      </option>
                      <option value="active">{t("O_ACTIVE")}</option>
                      <option value="inactive">{t("O_INACTIVE")}</option>
                    </select>
                  </div>

                  <button title={t("O_RESET")} type="button" onClick={handleReset} className="bg-gradientTo text-sm px-6 flex gap-2 ml-3 mb-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue sm:w-auto w-1/2">
                    <BiReset size={18} /> {t("O_RESET")}
                  </button>

                </div>
              </div>

              <div className="lg:pt-0 pt-2">
                <label htmlFor="default-search" className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white">
                  {t("O_SEARCH")}
                </label>
              </div>
              <div className="flex">
                <button
                  type="button"
                  title={t("ADD_VEHICLE")}
                  className="bg-gradientTo text-sm flex gap-2 px-5 ml-3 mb-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue sm:w-auto "
                  onClick={() => setCategoryAdd({open:true})}
                >
                  <IoMdAdd size={18} /> {t("ADD_VEHICLE")}
                </button>
              </div>
            </form>

            <AnimatedComponent>
              <CustomerTable country={customer} allSubAdmin={allSubAdmin} page={page} setSort={setSort} sort={sort} setCategoryAdd={setCategoryAdd}/>
            </AnimatedComponent>
            {paginationObj?.totalItems ? <Pagination handlePageClick={handlePageClick} options={paginationObj} page={page} /> : null}
          </div>
        </div>
      </div>

      {categoryAdd && <VehicleAdd categoryAdd={categoryAdd} getAllNotifications={allSubAdmin} handleCategory={handleCategory} />}
    </div>
  );
}

export default VehicleManager;
